export default {
  'sendverificationsms.sendverificationsms': 'REQUEST VERIFICATION CODE',
  'sendverificationsms.maintext':
    'By clicking Send me Sms button you will recieve a message on your registered phone which contains a verification code that allows you to register',
  'sendverificationsms.sendsms': 'PLEASE SEND ME SMS',
};
